import { systemActionsConstants } from "../actions";
import {
  _sharedReducerSettings,
  _sharedStateSettings
} from "@/shared/store/settings/reducer";
import { SETTING } from "@/shared/utils/settings/constants";
import {
  getStoredSettingsNextApp, getDefaultSettingsNextApp
} from "../../utils/settings/settings";

const methodGetSettingsInitial = ("window" in global)
  ? getStoredSettingsNextApp : getDefaultSettingsNextApp;

export const initialState = {
  ..._sharedStateSettings,
  ...methodGetSettingsInitial(),
};

const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case systemActionsConstants.SET_IS_LOGIN: {
      if (action.data || action.isFetchInitLoad) {
        return state;
      }

      const storedSettings = getStoredSettingsNextApp();
      const newInitState = { ...initialState, ...storedSettings };
      const settingsKeys = Object.keys(SETTING);

      settingsKeys.forEach((settingName) => {
        const { saveOnLogout } = SETTING[settingName];

        if (Object.hasOwnProperty.call(initialState, settingName) && saveOnLogout) {
          newInitState[settingName] = state[settingName];
        }
      });

      return newInitState;
    }
    default:
      return _sharedReducerSettings(state, action);
  }
};

export default settingsReducer;
